import React, { useState } from "react";
import Pelak from "../../pelak-car";
import { CiEdit } from "react-icons/ci";
import { Link } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import BottomSheet2 from "../../buttom-page/bottom-page";
import DeleteCar from "../delete/delete-car";
import EditKilometer from "./edit-kilometer";
import styles from "./CardSingleTop.module.css";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdBuild, MdOutlineCalendarMonth } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";

const CardSingleTop = ({ car }) => {
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenEditKilometer, setIsOpenEditKilometer] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);


  const imageSrc = car.imageUrl || "/default-avatar.png";

  const formatPrice = (price = 0) => {
    if (price >= 1000000)
      return `${(price / 1000000).toFixed(1)}M`;
  
    if (price >= 1000)
      return `${(price / 1000).toFixed(0)}K`;
  
    return price;
  };

  return (
    <div className={`card shadow-sm h-100 ${styles.card}`}>
      
      {/* تصویر فقط برای دسکتاپ */}
      {/* <div className="d-none d-md-block">
        <div
          className={styles.imageWrapper}
          style={{ "--bg-image": `url(${imageSrc})` }}
        >
          <img
            src={imageSrc}
            alt="خودرو"
            className={styles.mainImage}
          />
        </div>
      </div> */}

      <div className="card-body">

        {/* ردیف موبایل: تصویر + اطلاعات */}
                  {/* تصویر دایره‌ای موبایل */}
        {/* <div className="row align-items-center mb-2 d-md-none">
          <div className="col-auto">
            <div className={styles.imageWrapper}>
              <img
                src={imageSrc}
                alt="خودرو"
                className={styles.mainImage}
              />
            </div>
          </div>
        </div> */}

        {/* اطلاعات دسکتاپ */}
        {/* <div className="row align-items-start d-none d-md-flex">
          <div className="col">
            <div className="mb-2 row">
              <div className="col-4 text-start">{car.productYear}</div>
              <div className="col-8 text-end fw-bold">{car.title}</div>
            </div>

            <div className="mb-2 row">
              <div className="col-4 text-start">{car.distancePerWeek}</div>
              <div className="col-8 text-end fw-bold">
                :حرکت هفتگی(کیلومتر)
              </div>
            </div>
          </div>
        </div> */}

        {/* // جدید */}
        {/* HEADER */}
        <div className={styles.header}>
          <div className={styles.headerTop}>

            {/* Avatar */}
            <div className={styles.avatarWrapper}>
              <img
                src={imageSrc}
                alt={car.title}
                className={styles.avatar}
              />
            </div>

            {/* Info */}
            <div className={styles.headerInfo}>
              <div className={styles.title}>
                {car.title}
              </div>

              <div className={styles.subHeader}>
                {/* <div className={styles.subItem}>
                  <span>🚗</span>
                  <span>{car.distancePerWeek} km/هفته</span>
                </div>

                <div className={styles.subDivider} /> */}

                <div className={styles.subItem}>
                  <span>📅</span>
                  <span>{car.productYear}</span>
                </div>
              </div>
            </div>

            {/* Menu */}
            <button
              className={styles.menuBtn}
              onClick={() => setOpenMenu(true)}
            >
              <BsThreeDotsVertical />
            </button>

          </div>
        </div>
        
        {/* KPI BAR */}
        <div className={styles.kpiBar}>
          <div className={styles.kpiItem}>
            <FaMoneyBillWave className={styles.money} />
            <span className={styles.kpiValue}>
              {formatPrice(car.totalCost)}
            </span>
          </div>

          <div className={styles.kpiDivider} />

          <div className={styles.kpiItem}>
            <MdBuild className={styles.service} />
            <span className={styles.kpiValue}>
              {car.servicesCount || 0}
            </span>
          </div>

          <div className={styles.kpiDivider} />

          <div className={styles.kpiItem}>
            <MdOutlineCalendarMonth className={styles.calendar} />
            <span className={styles.kpiValue}>
              {car.daysFromLastService !== undefined && 
              car.daysFromLastService !== null && 
              car.daysFromLastService !== -1 
                ? car.daysFromLastService 
                : "-"}
            </span>
          </div>
        </div>

        {/* META BAR */}
        <div className={styles.metaBar}>
          <div className={styles.metaItem}>
            <div className={`flex-fill ${styles.pelakWrapper}`}>
              <Pelak
                part1Pelak={car.pelak1}
                part2Pelak={car.pelak2}
                part3Pelak={car.pelak3}
                part4Pelak={car.pelak4}
              />
            </div>
          </div>

          <div className={styles.kpiDivider} />

          <div className={styles.metaItem}>
            <span className={styles.metaIcon}>🚗</span>
            <span className={styles.metaText}>
              {car.kilometer.toLocaleString()} km
            </span>
          </div>

          <button
            className={styles.editBtn}
            onClick={() => setIsOpenEditKilometer(true)}
          >
            ✏️
          </button>
        </div>
        {/* // End */}





        {/* کیلومتر + پلاک (مشترک موبایل و دسکتاپ) */}
        {/* <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
          <div className="flex-fill">
            <div className="d-flex align-items-center gap-2">
              <div className="flex-grow-1">
                <KilometerCar kilometer={car.kilometer} />
              </div>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setIsOpenEditKilometer(true)}
              >
                <CiEdit size={18} />
              </button>
            </div>
          </div>

          <div className={`flex-fill ${styles.pelakWrapper}`}>
            <Pelak
              part1Pelak={car.pelak1}
              part2Pelak={car.pelak2}
              part3Pelak={car.pelak3}
              part4Pelak={car.pelak4}
            />
          </div>
        </div> */}
      </div>

      {/* فوتر */}
      {/* <div className="card-footer text-muted">
        <div className="d-flex gap-2">
          <Link
            className="btn btn-outline-info btn-sm flex-fill"
            to={`/edit-car/${car.id}`}
          >
            <CiEdit size={18} /> ویرایش
          </Link>

          <button
            className="btn btn-outline-danger btn-sm flex-fill"
            onClick={() => setIsOpenDelete(true)}
          >
            <RiDeleteBinLine size={18} /> حذف
          </button>

          <button
            className={styles.menuBtn}
            onClick={() => setOpenMenu(true)}
          >
            ⋯
          </button>
        </div>
      </div> */}

      {/* BottomSheet حذف */}
      <BottomSheet
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        snapPoint="250"
      >
        <DeleteCar
          car={car}
          closeButtomSheetHandler={() => setIsOpenDelete(false)}
        />
      </BottomSheet>

      {/* BottomSheet ویرایش کیلومتر */}
      <BottomSheet
        isOpen={isOpenEditKilometer}
        onClose={() => setIsOpenEditKilometer(false)}
        snapPoint="250"
      >
        <EditKilometer
          car={car}
          closeButtomSheetHandler={() =>
            setIsOpenEditKilometer(false)
          }
        />
      </BottomSheet>

      {/* BottomSheet دکمه های ویرایش و حذف خودرو*/}
      <BottomSheet2
        isOpen={openMenu}
        onClose={() => setOpenMenu(false)}
      >
        <div className={styles.sheetTitle}>
          <div>🚗 {car.title}</div>
          <small>مدل {car.productYear}</small>
        </div>

        <Link className={styles.sheetAction} to={`/edit-car/${car.id}`}>
          <span>✏️</span>
          <span>ویرایش خودرو</span>
        </Link>

        <button
          className={`${styles.sheetAction} ${styles.danger}`}
          onClick={() => setIsOpenDelete(true)}
        >
          <span>🗑</span>
          <span>حذف خودرو</span>
        </button>

        <button
          className={styles.cancelBtn}
          onClick={() => setOpenMenu(false)}
        >
          انصراف
        </button>
      </BottomSheet2>
    </div>
  );
};

export default CardSingleTop;
